"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Location extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'location';
        this._name = initParams.name;
        this._lat = initParams.lat;
        this._timezone = initParams.timezone;
        this._lng = initParams.lng;
        this._metadata = initParams.metadata;
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateLocation(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set lat(value) {
        console.error('Do not set objects this way');
    }
    setLat(value) {
        return this.dataService.updateLocation(this.id, { lat: value }, this);
    }
    get lat() {
        return this._lat;
    }
    set timezone(value) {
        console.error('Do not set objects this way');
    }
    setTimezone(value) {
        return this.dataService.updateLocation(this.id, { timezone: value }, this);
    }
    get timezone() {
        return this._timezone;
    }
    set lng(value) {
        console.error('Do not set objects this way');
    }
    setLng(value) {
        return this.dataService.updateLocation(this.id, { lng: value }, this);
    }
    get lng() {
        return this._lng;
    }
    set metadata(value) {
        console.error('Do not set objects this way');
    }
    setMetadata(value) {
        return this.dataService.updateLocation(this.id, { metadata: value }, this);
    }
    get metadata() {
        return this._metadata;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateLocation(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateLocation(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteLocation(this.id, this);
    }
}
exports.default = Location;
//# sourceMappingURL=location.js.map